// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Linkedin: React.FC = () => {
    return <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Global-Elements/Footer-WF" transform="translate(-1103.000000, -194.000000)" fill="#9C5F16">
            <g transform="translate(1027.000000, 155.000000)">
                <g transform="translate(0.000000, 29.000000)">
                    <g transform="translate(65.000000, 0.000000)">
                        <path d="M24.2216387,15.6471806 C26.6539613,15.6471806 28.5654452,17.2236323 28.5654452,20.6175032 L28.5654452,20.6175032 L28.5654452,26.7102129 L24.6832516,26.7102129 L24.6832516,21.0402129 C24.6832516,19.5555032 24.0764774,18.5428581 22.7404129,18.5428581 C21.7190581,18.5428581 21.1517677,19.2262774 20.8869935,19.8853097 C20.8211871,20.0428581 20.8057032,20.2416968 20.8026925,20.454643 L20.8028,26.7102129 L16.9566065,26.7102129 L16.9566065,26.7102129 L16.9568195,26.6667274 C16.9588381,26.2516412 16.9745957,22.9418766 16.9781077,20.0636522 L16.978145,18.1016295 C16.9762556,16.9062727 16.9700506,15.998605 16.9566065,15.7528581 L16.9566065,15.7528581 L20.8028,15.7528581 L20.8028,17.472729 C21.0304129,16.7207935 22.2590581,15.6471806 24.2216387,15.6471806 Z M14.8670968,15.7528581 L14.8670968,26.7102129 L11.4430323,26.7102129 L11.4430323,15.7528581 L14.8670968,15.7528581 Z M13.0913097,10.5807032 C14.3542129,10.5807032 15.1316968,11.3988323 15.1560839,12.4799935 C15.1560839,13.5419935 14.3542129,14.3821871 13.0669226,14.3821871 L13.0669226,14.3821871 L13.0425355,14.3821871 C11.8034387,14.3821871 10.9998258,13.5443161 10.9998258,12.4834774 C10.9998258,11.4011548 11.8272452,10.5807032 13.0913097,10.5807032 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Linkedin);
